module.exports = __webpack_public_path__ + "img/Oregon outline.b3a19a14.png";